import React from "react";

const AboutUs = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-12 flex flex-col md:flex-row items-center gap-10">
        {/* Left Image */}
        <div className="md:w-1/2 w-full">
          <img
            src="https://themes.muffingroup.com/be/accountant4/wp-content/uploads/2022/03/accountan4-home-pic1.webp"
            alt="Navishaa Microsoft Cloud Experts"
            className="rounded-lg  w-full h-auto object-cover"
          />
        </div>

        {/* Right Content */}
        <div className="md:w-1/2 w-full text-center md:text-left">
          <h2 className=" text-3xl lg:text-[30px] font-bold text-gray-900 leading-snug mb-4">
            Empowering Businesses with{" "}
            <span className="bg-gradient-to-r from-[#414de1] to-[#b241e1] bg-clip-text text-transparent">
              Microsoft Cloud Expertise
            </span>
          </h2>
          <p className="text-gray-700 mb-2 text-sm md:text-base">
            At <strong>Navishaa</strong>, we specialize in delivering{" "}
            <strong>Resource-as-a-Service (RaaS)</strong> solutions that help
            organizations leverage the full power of Microsoft technologies
            without the cost and complexity of traditional hiring.
          </p>
          <p className="text-gray-700 mb-2 text-sm md:text-base">
            Our certified experts bring deep knowledge of{" "}
            <strong>Microsoft 365, Azure, Dynamics 365, Power Platform,</strong>{" "}
            and <strong>Microsoft Copilot</strong>, enabling enterprises to
            transform, scale, and optimize seamlessly.
          </p>
          <p className="text-gray-700 mb-4 text-sm md:text-base">
            By combining on-demand scalability, cost efficiency, and trusted
            expertise, we empower businesses to drive innovation, strengthen
            security, and achieve measurable outcomes—faster. We are committed
            to being your trusted technology partner, ensuring long-term success
            through flexible engagement models, transparent processes, and
            proven delivery excellence.
          </p>
          <button
            className="px-4 py-1.5 border border-[#414de1] font-semibold rounded-md 
                        bg-gradient-to-r from-[#414de1] to-[#b241e1] bg-clip-text text-transparent 
                     hover:bg-[#ba195f] hover:text-[#ba195f] transition"
            aria-label="Learn More"
          >
            Learn More →
          </button>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
